import { render, staticRenderFns } from "./Efetividade.vue?vue&type=template&id=257cccd4"
import script from "./Efetividade.vue?vue&type=script&lang=js"
export * from "./Efetividade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports